import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-page-content wiki-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WikiBreadCrumbs = _resolveComponent("WikiBreadCrumbs")!
  const _component_WikiRoleGuide = _resolveComponent("WikiRoleGuide")!
  const _component_LocalizedTextWrapper = _resolveComponent("LocalizedTextWrapper")!
  const _component_TopRolePlayer = _resolveComponent("TopRolePlayer")!
  const _component_WikiPlayCta = _resolveComponent("WikiPlayCta")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_WikiBreadCrumbs),
    _createElementVNode("h1", null, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "evil-loyalty-icon" }, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('roles.morgana')) + " " + _toDisplayString(_ctx.$t('roles.role')), 1)
    ]),
    _createVNode(_component_WikiRoleGuide, { role: "morgana" }),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('morgana.generalInformation')), 1),
    _createElementVNode("p", null, [
      _createVNode(_component_LocalizedTextWrapper, { keypath: "morgana.playingAsMorgana" })
    ]),
    _createVNode(_component_TopRolePlayer, {
      role: "morgana",
      class: "my-4"
    }),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('morgana.generalTips')), 1),
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('morgana.masterArtOfDeceptionTitle')), 1),
        _createVNode(_component_LocalizedTextWrapper, { keypath: "morgana.masterArtOfDeceptionDescription" })
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('morgana.createConfusionTitle')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('morgana.createConfusionDescription')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('morgana.coordinateEvilPlayersTitle')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('morgana.coordinateEvilPlayersDescription')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('morgana.stayComposedTitle')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('morgana.stayComposedDescription')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('morgana.adaptStrategyTitle')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('morgana.adaptStrategyDescription')), 1)
      ])
    ]),
    _createElementVNode("p", null, [
      _createVNode(_component_LocalizedTextWrapper, { keypath: "morgana.thrivingAsMorgana" })
    ]),
    _createVNode(_component_WikiPlayCta)
  ]))
}